import React, {Component} from 'react';

class Header extends Component {
    render() {
        let name, jobDescription, company, city, networks;

        if (this.props.data) {
            name = this.props.data.name;
            jobDescription = this.props.data.jobDescription;
            company = this.props.data.company;
            city = this.props.data.address.city;
            networks = this.props.data.social.map(function (network) {
                return (
                    <li key={network.name}>
                        <a href={network.url}><i className={network.className}></i></a>
                    </li>
                );
            });
        }

        return (
            <header id="home">
                <nav id="nav-wrap">
                    <a className="mobile-btn" href="#nav-wrap" title="Show navigation">Show navigation</a>
                    <a className="mobile-btn" href="#home" title="Hide navigation">Hide navigation</a>

                    <ul id="nav" className="nav">
                        <li className="current"><a className="smoothscroll" href="#home">Home</a></li>
                        <li><a className="smoothscroll" href="#about">About</a></li>
                        <li><a className="smoothscroll" href="#resume">Resume</a></li>
                        <li><a className="smoothscroll" href="#portfolio">Works</a></li>
                        <li><a className="smoothscroll" href="#testimonials">Testimonials</a></li>
                        <li><a className="smoothscroll" href="#contact">Contact</a></li>
                    </ul>
                </nav>

                <div className="row banner">
                    <div className="banner-text">
                        <h1 className="responsive-headline">I'm {name}</h1>
                        <h3>I am a professional <span>{jobDescription}</span> working
                            at <a href="https://www.seetickets.com/"><span>{company}</span></a> in <span>{city}</span>.
                            I'm specialized in <span>Python web-development</span>,
                            and an expert in <span>Django</span> and <span>Flask</span>, for which I've developed
                            the <a href="https://github.com/flask-dashboard/Flask-MonitoringDashboard">
                                <span>Flask-Monitoring-Dashboard</span>
                            </a>. Currently, I'm still the maintainer of this
                            repository, and continuously adding new features.</h3>
                        <hr/>
                        <ul className="social">
                            {networks}
                        </ul>
                    </div>
                </div>
                <p className="scrolldown">
                    <a className="smoothscroll" href="#about"><i className="icon-down-circle"></i></a>
                </p>
            </header>
        );
    }
}

export default Header;



// WEBPACK FOOTER //
// ./src/Components/Header.js